import styled from "styled-components";

export const ArchiveContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-color: transparent;
  margin: 40px auto;
  overflow-y: auto;
  padding-right: 10px;
  h2 {
    font-size: 18px;
    font-weight: 700;
    direction: rtl;
    color: #27548c;
    /* margin-bottom: 18px; */
  }

  @media (max-width: 1024px) {
    height: unset;
  }

  @media (max-width: 360px) {
    width: calc(360px - 32px);
    /* margin-top: 100px; */
    padding-bottom: 0;
  }
`;
export const Container = styled.div`
  width: 100%;

  border-radius: 16px;
  padding: 40px 60px 20px 60px;
  /* min-height: 600px; */
  /* overflow-x: hidden; */
  direction: rtl;
  background: #ffffff;
  height: 700px;
  box-shadow: 2px 4px 10px rgba(108, 136, 170, 0.25);
  @media (max-width: 1024px) {
    background-color: unset;
    box-shadow: none;
    padding: 100px 16px 200px 16px;
    // overflow-y: hidden;
    height: fit-content;
    box-shadow: none;
  }

  div {
    width: 100%;
  }
`;

export const Nodata = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto !important;
  margin-top: 10rem;
  height: 100%;
  h4 {
    color: #27548c;
  }
`;
